export const CREATE_REPLACEMENT = 'SAGA/CREATE_REPLACEMENT';

export const createReplacement = (payload) => {
  return {
    type: CREATE_REPLACEMENT,
    payload,
  };
};
